import React from 'react';

function DocumentCard({ data, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const renderField = (label, field, value) => (
    <div className="card-field">
      <div className="field-label">{label}</div>
      <input
        type="text"
        className="field-input"
        value={value || ''}
        onChange={(e) => handleChange(field, e.target.value)}
        placeholder="No disponible"
      />
    </div>
  );

  return (
    <div className="data-card">
      <div className="card-header">
        <h3>Documento</h3>
      </div>
      <div className="card-body">
        {renderField('Tipo', 'tipo', data.tipo)}
        {renderField('Numero', 'numero', data.numero)}
        {renderField('Fecha emision', 'fecha_emision', data.fecha_emision)}
        {renderField('Fecha vencimiento', 'fecha_vencimiento', data.fecha_vencimiento)}
        {renderField('Forma de pago', 'forma_pago', data.forma_pago)}
      </div>
    </div>
  );
}

export default DocumentCard;
